import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import SchematicImg from "@/views/consult/components/SchematicImg.vue";
export default {
  name: "commonProblemModal",
  components: {
    SchematicImg: SchematicImg
  },
  data: function data() {
    return {
      imgUrlZh: "",
      imgUrlEn: "",
      imgUrlTw: "",
      lang: "zh",
      max: 4,
      orange: {
        questionZh: "",
        answerZh: "",
        questionEn: "",
        answerEn: "",
        questionTw: "",
        answerTw: "",
        imgs: [],
        imgsEn: [],
        imgsTw: [],
        isRecommend: 0
      },
      form: {},
      dialogVisible: false,
      rules: {
        questionZh: [{
          required: true,
          message: "请输入问题",
          trigger: "blur"
        }],
        answerZh: [{
          required: true,
          message: "请输入回答",
          trigger: "blur"
        }],
        questionEn: [{
          required: false,
          message: "请输入问题",
          trigger: "blur"
        }],
        answerEn: [{
          required: false,
          message: "请输入回答",
          trigger: "blur"
        }],
        questionTw: [{
          required: false,
          message: "请输入问题",
          trigger: "blur"
        }],
        answerTw: [{
          required: false,
          message: "请输入回答",
          trigger: "blur"
        }]
      }
    };
  },
  watch: {
    "form.isRecommend": {
      handler: function handler(val) {
        var _this = this;
        var keyArr = ["questionEn", "answerEn", "questionTw", "answerTw"];
        keyArr.forEach(function (key) {
          return _this.rules[key][0].required = val === 1;
        });
      }
    }
  },
  methods: {
    show: function show(row, categoryId) {
      this.form = row ? JSON.parse(JSON.stringify(row)) : JSON.parse(JSON.stringify(this.orange));
      this.form.categoryId = categoryId;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this2 = this;
      this.$refs.ruleForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var keyArr, _i, _keyArr, key, res;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!valid) {
                  _context.n = 8;
                  break;
                }
                if (!(_this2.form.isRecommend === 1)) {
                  _context.n = 3;
                  break;
                }
                keyArr = ["questionZh", "answerZh", "questionEn", "answerEn", "questionTw", "answerTw"];
                _i = 0, _keyArr = keyArr;
              case 1:
                if (!(_i < _keyArr.length)) {
                  _context.n = 3;
                  break;
                }
                key = _keyArr[_i];
                if (_this2.form[key]) {
                  _context.n = 2;
                  break;
                }
                return _context.a(2, _this2.$message.warning("请完成中英繁全部问题与回答内容"));
              case 2:
                _i++;
                _context.n = 1;
                break;
              case 3:
                res = null;
                if (!_this2.form.id) {
                  _context.n = 5;
                  break;
                }
                _context.n = 4;
                return _this2.$api.updateFaqAdvisory(_this2.form);
              case 4:
                res = _context.v;
                _this2.$operationLog.push({
                  operationType: "text",
                  code: "update",
                  detailBatchNo: _this2.form.questionZh
                });
                _context.n = 7;
                break;
              case 5:
                _context.n = 6;
                return _this2.$api.addFaqAdvisory(_this2.form);
              case 6:
                res = _context.v;
                _this2.$operationLog.push({
                  operationType: "text",
                  code: "add",
                  detailBatchNo: _this2.form.questionZh
                });
              case 7:
                if (res.code == 200) {
                  _this2.dialogVisible = false;
                  _this2.$emit("save");
                }
                _context.n = 9;
                break;
              case 8:
                return _context.a(2, false);
              case 9:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    close: function close() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.$refs.ruleForm.clearValidate();
        _this3.$refs.ruleForm.resetFields();
        _this3.lang = "zh";
      });
    }
  }
};